import styled from 'styled-components';

export const SearchPopupContent = styled.div`
  padding: 15px;
  padding-bottom: 150px;
  height: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow: scroll;

  > div:first-child {
    background-color: ${({ theme }) => theme.colors.background.primary};
    margin-bottom: 15px;

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }

    @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      margin-bottom: 20px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 20px 25px;
    padding-bottom: 120px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 20px 45px;
    padding-bottom: 120px;
  }
`;
